export default __webpack_public_path__ + "static/media/Porsche.1e24af09.png";